import React from 'react';

/**
 * A fieldset component
 * @param {{
 *   legend?: string,
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
export const Fieldset = (props) => {
  const {
    children,
    legend,
  } = props;

  return (
    <fieldset className="border border-solid border-griege rounded p-4 mb-5 md:border-l-0 md:border-r-0 md:border-t-0 md:border-b md:rounded-none md:py-3 md:px-1.5">
      {legend && <legend className="font-bold px-4 text-md uppercase tracking-wider">{legend}</legend>}
      {children}
    </fieldset>
  );
};
